import Header from "../pages/header";
import Login from "../pages/login/login";
import Logout from "../pages/logout";
import PageNotFound from "../pages/pagenotfound";
import PATH from "./path";
import { Navigate } from "react-router";
import PAGE_KEYS from "./page_key";
import Register from "../pages/register/register";
import { AuthGuard } from "../authguard";
import Transaction from "../pages/transaction/transaction";
import Party from "../pages/party/party";
import Products from "../pages/items/items";
import Items from "../pages/items/items";
import Dashboard from "../pages/dashboard/dashboard";
import Purchase from "../pages/purchase/purchase";
import CreatePurchase from "../pages/purchase/createPurchase";
import Sale from "../pages/sale/sale";
import CreateSale from "../pages/sale/createSale";
import ReturnPage from "../pages/returns/returnItems";
import Bussiness from "../pages/business/Bussiness";
import Privacy from "../pages/privacy-policy";
import TermsCondition from "../pages/termCondition";
import { PublicGuard } from "../publicguard";
import CreateBusiness from "../pages/business/createbusiness";
import AddBusiness from "../pages/business/addbusiness";
import PurchaseOrder from "../pages/purchase/purchaseOrder";
import SaleOrder from "../pages/sale/saleOrder";
import SaleInvoice from "../pages/sale/saleInvoice";
import PurchaseOrderList from "../pages/purchase/purchaseOrderList";
import Expenses from "../pages/expenses/Expenses";
import Services from "../pages/services/Services";
import SaleOrderList from "../pages/sale/saleOrderList";
import Reports from "../pages/reports/reports";
import AddService from "../pages/services/AddService";
import AddItem from "../pages/items/AddItem";
import Unit from "../pages/items/unit";
import Category from "../pages/items/category";
import AddParty from "../pages/party/addParty";
import ServicesCategory from "../pages/services/servicesCategory";
import ExpenseCategory from "../pages/expenses/expenseCategory";
import Employee from "../pages/employee/employee";
import AddEmployee from "../pages/employee/addEmployee";
import Attendance from "../pages/employee/attendance";
import ZoomControls from "../pages/zoomControls";
import Shift from "../pages/employee/shift";
import PartyDetails from "../pages/party/partyDetails";
import Home from "../pages/home/home";
import Pricing from "../pages/home/pricing";
import Features from "../pages/home/features";
import Partner from "../pages/home/partner";
import FeaturesSection from "../pages/home/featuressection";
import Industry from "../pages/home/industry";
import IndustryData from "../pages/home/industrydata";
import ItemDetails from "../pages/items/ItemDetails";
import Account from "../pages/account/Account";
import BulkUploadItems from "../pages/items/BulkUploadItems";
import Prefix from "../pages/prefix";
import BulkUploadParty from "../pages/party/BulkUploadParty";
import BulkUploadServices from "../pages/services/BulkUploadServices";
import Location from "../pages/items/Location";

const ROUTES = [
  // {
  //   exact: true,
  //   path: PATH.root,
  //   Component: () => <Navigate to={PATH.login} />,
  // },
  {
    exact: true,
    path: PATH.root,
    Component: () => <Home />,
  },
  {
    exact: true,
    path: PATH.pricing,
    Component: () => <Pricing />,
    key: PAGE_KEYS.pricing,
  },
  {
    exact: true,
    path: PATH.features,
    Component: () => <Features />,
    key: PAGE_KEYS.features,
  },
  {
    exact: true,
    path: PATH.featuressection,
    Component: () => <FeaturesSection />,
    key: PAGE_KEYS.featuressection,
  },
  {
    exact: true,
    path: PATH.industry,
    Component: () => <Industry />,
    key: "industry",
  },
  {
    exact: true,
    path: PATH.industrydata,
    Component: () => <IndustryData />,
    key: PAGE_KEYS.industrydata,
  },
  {
    exact: true,
    path: PATH.partner,
    Component: () => <Partner />,
    key: PAGE_KEYS.partner,
  },

  {
    exact: true,
    path: PATH.login,
    Component: () => (
      <PublicGuard>
        <Login />
      </PublicGuard>
    ),
  },
  {
    exact: true,
    path: PATH.register,
    Component: Register,
  },
  {
    exact: true,
    path: PATH.privacy,
    Component: Privacy,
  },
  {
    exact: true,
    path: PATH.terms,
    Component: TermsCondition,
  },

  {
    exact: true,
    path: PATH.business,
    Component: Bussiness,
    key: PAGE_KEYS.business,
  },
  {
    exact: true,
    path: PATH.createbusiness,
    Component: () => (
      <AuthGuard>
        <CreateBusiness />
      </AuthGuard>
    ),
    key: PAGE_KEYS.createBusiness,
  },
  {
    exact: true,
    path: PATH.addBusiness,
    Component: () => (
      <AuthGuard>
        <AddBusiness />
      </AuthGuard>
    ),
    key: PAGE_KEYS.addBusiness,
  },
  {
    exact: true,
    path: PATH.logout,
    Component: Logout,
  },
  {
    exact: true,
    path: PATH.dashboard,
    Component: () => (
      <AuthGuard>
        <Dashboard />
      </AuthGuard>
    ),
    key: PAGE_KEYS.dashboard,
  },
  {
    exact: true,
    path: PATH.party,
    Component: () => (
      <AuthGuard>
        <Party />
      </AuthGuard>
    ),
    key: PAGE_KEYS.party,
  },
  {
    exact: true,
    path: PATH.bulkUploadParty,
    Component: () => (
      <AuthGuard>
        <BulkUploadParty />
      </AuthGuard>
    ),
    key: PAGE_KEYS.party,
  },
  {
    exact: true,
    path: PATH.addParty,
    Component: () => (
      <AuthGuard>
        <AddParty />
      </AuthGuard>
    ),
    key: PAGE_KEYS.party,
  },
  {
    exact: true,
    path: PATH.editParty,
    Component: () => (
      <AuthGuard>
        <AddParty />
      </AuthGuard>
    ),
    key: PAGE_KEYS.editParty,
  },
  {
    exact: true,
    path: PATH.partyDetails,
    Component: () => (
      <AuthGuard>
        <PartyDetails />
      </AuthGuard>
    ),
    key: PAGE_KEYS.partyDetails,
  },
  {
    exact: true,
    path: PATH.services,
    Component: () => (
      <AuthGuard>
        <Services />
      </AuthGuard>
    ),
    key: PAGE_KEYS.services,
  },
  {
    exact: true,
    path: PATH.bulkUploadServices,
    Component: () => (
      <AuthGuard>
        <BulkUploadServices />
      </AuthGuard>
    ),
    key: PAGE_KEYS.services,
  },
  {
    exact: true,
    path: PATH.addServices,
    Component: () => (
      <AuthGuard>
        <AddService />
      </AuthGuard>
    ),
    key: PAGE_KEYS.services,
  },
  {
    exact: true,
    path: PATH.servicesCategory,
    Component: () => (
      <AuthGuard>
        <ServicesCategory />
      </AuthGuard>
    ),
    key: PAGE_KEYS.servicesCategory,
  },
  {
    exact: true,
    path: PATH.purchase,
    Component: () => (
      <AuthGuard>
        <Purchase />
      </AuthGuard>
    ),
    key: PAGE_KEYS.purchase,
  },
  {
    exact: true,
    path: PATH.createPurchase,
    Component: () => (
      <AuthGuard>
        <CreatePurchase />
      </AuthGuard>
    ),
    key: PAGE_KEYS.createPurchase,
  },
  {
    exact: true,
    path: PATH.purchaseOrder,
    Component: () => (
      <AuthGuard>
        <PurchaseOrder />
      </AuthGuard>
    ),
    key: PAGE_KEYS.purchase,
  },
  {
    exact: true,
    path: PATH.purchase_order_list,
    Component: () => (
      <AuthGuard>
        <PurchaseOrderList />
      </AuthGuard>
    ),
    key: PAGE_KEYS.purchase_order_list,
  },

  {
    exact: true,
    path: PATH.sale,
    Component: () => (
      <AuthGuard>
        <Sale />
      </AuthGuard>
    ),
    key: PAGE_KEYS.sale,
  },
  {
    exact: true,
    path: PATH.createSale,
    Component: () => (
      <AuthGuard>
        <CreateSale />
      </AuthGuard>
    ),
    key: PAGE_KEYS.createSale,
  },
  {
    exact: true,
    path: PATH.saleOrder,
    Component: () => (
      <AuthGuard>
        <SaleOrder />
      </AuthGuard>
    ),
    key: PAGE_KEYS.sale_order,
  },

  {
    exact: true,
    path: PATH.saleOrderlist,
    Component: () => (
      <AuthGuard>
        <SaleOrderList />
      </AuthGuard>
    ),
    Key: PAGE_KEYS.sale,
  },

  //{
  //  exact: true,
  //  path: PATH.saleOrderlist,
  // Component: () => (
  //  <AuthGuard>
  //   <SaleOrderList />
  // </AuthGuard>
  // ),
  // key: PAGE_KEYS.saleOrderList,
  //},
  {
    exact: true,
    path: PATH.saleInvoice,
    Component: () => (
      <AuthGuard>
        <SaleInvoice />
      </AuthGuard>
    ),
    key: PAGE_KEYS.sale,
  },
  {
    exact: true,
    path: PATH.items,
    Component: () => (
      <AuthGuard>
        <Items />
      </AuthGuard>
    ),
    key: PAGE_KEYS.items,
  },
  {
    exact: true,
    path: PATH.bulkUploadItems,
    Component: () => (
      <AuthGuard>
        <BulkUploadItems />
      </AuthGuard>
    ),
    key: PAGE_KEYS.items,
  },
  {
    exact: true,
    path: PATH.category,
    Component: () => (
      <AuthGuard>
        <Category />
      </AuthGuard>
    ),
    key: PAGE_KEYS.category,
  },
  {
    exact: true,
    path: PATH.location,
    Component: () => (
      <AuthGuard>
        <Location />
      </AuthGuard>
    ),
    key: PAGE_KEYS.location,
  },
  {
    exact: true,
    path: PATH.unit,
    Component: () => (
      <AuthGuard>
        <Unit />
      </AuthGuard>
    ),
    key: PAGE_KEYS.unit,
  },
  {
    exact: true,
    path: PATH.addItems,
    Component: () => (
      <AuthGuard>
        <AddItem />
      </AuthGuard>
    ),
    key: PAGE_KEYS.items,
  },
  {
    exact: true,
    path: PATH.itemDetails,
    Component: () => (
      <AuthGuard>
        <ItemDetails />
      </AuthGuard>
    ),
    key: PAGE_KEYS.itemDetails,
  },
  {
    exact: true,
    path: PATH.returns,
    Component: () => (
      <AuthGuard>
        <ReturnPage />
      </AuthGuard>
    ),
    key: PAGE_KEYS.returns,
  },
  {
    exact: true,
    path: PATH.expenses,
    Component: () => (
      <AuthGuard>
        <Expenses />
      </AuthGuard>
    ),
    key: PAGE_KEYS.expenses,
  },
  {
    exact: true,
    path: PATH.expensesCategory,
    Component: () => (
      <AuthGuard>
        <ExpenseCategory />
      </AuthGuard>
    ),
    key: PAGE_KEYS.expensesCategory,
  },
  {
    exact: true,
    path: PATH.reports,
    Component: () => (
      <AuthGuard>
        <Reports />
      </AuthGuard>
    ),
    key: PAGE_KEYS.reports,
  },
  {
    exact: true,
    path: PATH.transaction,
    Component: () => (
      <AuthGuard>
        <Transaction />
      </AuthGuard>
    ),
    key: PAGE_KEYS.transaction,
  },
  {
    exact: true,
    path: PATH.transactionDetail,
    Component: () => (
      <AuthGuard>
        <Transaction />
      </AuthGuard>
    ),
    key: PAGE_KEYS.transactionDetail,
  },
  {
    exact: true,
    path: PATH.shift,
    Component: () => (
      <AuthGuard>
        <Shift />
      </AuthGuard>
    ),
    key: PAGE_KEYS.shift,
  },
  {
    exact: true,
    path: PATH.employee,
    Component: () => (
      <AuthGuard>
        <Employee />
      </AuthGuard>
    ),
    key: PAGE_KEYS.employee,
  },
  {
    exact: true,
    path: PATH.addEmployee,
    Component: () => (
      <AuthGuard>
        <AddEmployee />
      </AuthGuard>
    ),
    key: PAGE_KEYS.employee,
  },
  {
    exact: true,
    path: PATH.editEmployee,
    Component: () => (
      <AuthGuard>
        <AddEmployee />
      </AuthGuard>
    ),
    key: PAGE_KEYS.editEmployee,
  },
  {
    exact: true,
    path: PATH.attendance,
    Component: () => (
      <AuthGuard>
        <Attendance />
      </AuthGuard>
    ),
    key: PAGE_KEYS.attendance,
  },
  {
    exact: true,
    path: PATH.zoomControls,
    Component: () => (
      <AuthGuard>
        <ZoomControls />
      </AuthGuard>
    ),
    key: PAGE_KEYS.zoomControls,
  },
  {
    exact: true,
    path: PATH.account,
    Component: () => (
      <AuthGuard>
        <Account />
      </AuthGuard>
    ),
    key: PAGE_KEYS.account,
  },
  {
    exact: true,
    path: PATH.prefix,
    Component: () => (
      <AuthGuard>
        <Prefix />
      </AuthGuard>
    ),
    key: PAGE_KEYS.prefix,
  },
  {
    path: PATH.createSale,
    Component: () => (
      <AuthGuard>
        <CreateSale />
      </AuthGuard>
    ),
    key: PAGE_KEYS.createSale,
  },
  {
    path: PATH.editSale,
    Component: () => (
      <AuthGuard>
        <CreateSale />
      </AuthGuard>
    ),
    key: PAGE_KEYS.createSale,
  },
  {
    path: "*",
    Component: PageNotFound,
  },
];

export default ROUTES;
